import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../components/Common/TextInput';
import CallOut from '../../components/Common/CallOut';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import { useTheme } from '../../DataStore/ThemeContext';
import { useSchool } from '../../DataStore/SchoolContext';
import { useVendor } from '../../DataStore/VendorContext';
import { useAccounts } from '../../DataStore/AccountsContext';
import VendorSelector from '../../components/Transaction/VendorSelector';
import ajaxGym from '../../util/remote/ajaxGym';

const initialState = {
    payee_id: '',
    discount_expense_account: '',
    discount_cash_account: '',
    api_key: '',
    student_src: '',
    class_src: '',
    residence_src: '',
    loading: false,
};

const reducer = (state, action) => {
    switch (action.type) {
        case "RESET":
            return { ...initialState };
        default:
            return { ...state, [action.type]: action.value };
    }
};

const ConfigGymValue = ({ field }) => {
    const { setNotify } = useTheme();
    const { getConfig } = useSchool();
    const { vendorListing, getVendorListing } = useVendor();
    const { getIncomeAccounts, incomeAccountListing, getLiabilityAccounts, liabilityAccountListing, getExpenseAccounts, expenseAccountListing} = useAccounts();

    const [state, dispatch] = useReducer(reducer, initialState);
    const [info, setInfo] = useState(null);

    useEffect(() => {
        const fetchData = () => {
            switch (field.config_code) {
                case 'payee_id':
                    getVendorListing();
                    break;
                case 'commission_payable':
                    getLiabilityAccounts();
                    break;
                case 'commission_expense':
                    getExpenseAccounts();
                    break;
                default:
                    getIncomeAccounts();
                    break;
            }
        };
        fetchData();
    }, [field]);

    useEffect(() => {
        if (info) {
            const timer = setTimeout(() => setInfo(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [info]);

    const handleSave = async (event) => {
        event.preventDefault();
        if (state.loading) return;

        dispatch({ type: 'loading', value: true });

        const serverResponse = await ajaxGym.setConfig(field.config_code, state[field.config_code].value || state[field.config_code]);
        dispatch({ type: 'loading', value: false });

        if (serverResponse.status === "OK") {
            const successNotification = <Notification type="success" message={serverResponse.message} />;
            setInfo(successNotification);
            setNotify(successNotification);

            setTimeout(() => getConfig(true), 2000);
        } else {
            setInfo(<Notification type="danger" message={serverResponse.message} />);
        }
    };

    const renderInputField = (type, label, placeholder, icon, valueKey) => (
        <TextInput
            type={type}
            label={label}
            placeholder={placeholder}
            leftIcon={icon}
            value={state[valueKey]}
            onChange={(e) => dispatch({ type: valueKey, value: e.target.value })}
            required
            wrap
        />
    );

    const RenderSelectInput = (label, placeholder, icon, list, refreshFn, actionType) => (
        <TextInput
            type="select"
            label={label}
            placeholder={placeholder}
            leftIcon={icon}
            options={(list || []).map((item) => ({
                label: `${item.account_number || ''} ${item.account_name || item.title || ''}`.trim(),
                value: item.account_id || item.payee_id,
            }))}
            onChange={(item) => dispatch({ type: actionType, value: item })}
            leftComponent={<i className={`fa ${icon} link`} onClick={refreshFn}></i>}
            loading={!list || list.length === 0}
            wrap
        />
    );

    return (
        <div className="card-body">
            <CallOut title={field.config_name} description={field.description} />
            {info}
            <form className="form-horizontal" onSubmit={handleSave}>
                {field.config_code === "payee_id"?
        
                    <VendorSelector 
                        onChange={(item) => dispatch({ type: "payee_id", value: item })} 
                        wrap label='Select Payee'
                        showCreate={false}
                        />
                    : field.config_code === "commission_payable" ?
                    RenderSelectInput(
                        field.config_name,
                        "Select commission account...",
                        "fa fa-university",
                        liabilityAccountListing,
                        () => getLiabilityAccounts(true),
                        field.config_code
                    ): field.config_code === "commission_expense" ?
                    RenderSelectInput(
                        field.config_name,
                        "Select commission expense account...",
                        "fa fa-university",
                        expenseAccountListing,
                        () => getExpenseAccounts(true),
                        field.config_code
                    ) :
                    RenderSelectInput(
                        field.config_name,
                        "Select income account...",
                        "fa fa-university",
                        incomeAccountListing,
                        () => getIncomeAccounts(true),
                        field.config_code
                    )}
              
              
              
                <div className="text-right">
                    {state.loading ? <ActivityLoader /> : <button type="submit" className="btn btn-lg btn-success">Save Configuration</button>}
                </div>
            </form>
        </div>
    );
};

export default ConfigGymValue;
